import { render } from "./LabeledTextareaField.vue?vue&type=template&id=6476bf34"
import script from "./LabeledTextareaField.vue?vue&type=script&lang=js"
export * from "./LabeledTextareaField.vue?vue&type=script&lang=js"
script.render = render

export default script